import { FC, ReactNode } from "react";
import classNames from "classnames";

import styles from "./button.module.scss";

interface Ibutton {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset" | undefined;
  disabled?: boolean;
  breakpoint?: string;
}

export const Button: FC<Ibutton> = ({
  children,
  className,
  onClick,
  type = "button",
  disabled,
  breakpoint = "desktop"
}) => {
  return (
    <button
      type={type}
      className={classNames(styles.button, className, styles[breakpoint])}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
